import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import { fetchSets, addSets } from "../../actions/settings"
import SetsRequItem from "./SetsRequItem"
import SettingsForm from './SettingsForm'

class SetsRequ extends SettingsForm {

  componentWillMount(){
    this.props.fetchSets('requ');
    this.props.fetchSets('comp');
    this.setState({
      adding:false,
      data:this.newItem,
      errors: {}
    });
  }

  modelName = 'requ'

  compId = parseInt(this.context.router.location.query.comp_id, 10)

  newItem = {
    requ_comp_id: this.compId,
    requ_desc: '',
    requ_long: '',
    requ_city: '',
    requ_addr: '',
    requ_inn: '',
    requ_kpp: '',
    requ_cacc: '',
    requ_bname: '',
    requ_bik: '',
    requ_baddr: '',
    requ_bacc: '',
    requ_dir: '',
    requ_buh: '',
    requ_active: 1
  }

  goBack = () => {
    this.context.router.goBack();
  }

  render() {
    if(isEmpty(this.props.requs.data)
      || isEmpty(this.props.comps.data)){
      return(<div>Не загружены данные</div>);
    }
    const requs = this.props.requs.data;
    const compDesc = this.props.comps.data[this.compId].comp_desc;
    const { data, errors } = this.state;

    var activeRequs = [];
    for(var key in requs){
      if(requs.hasOwnProperty(key) && requs[key].requ_active === 1
        && requs[key].requ_comp_id === parseInt(this.compId,10)){
        activeRequs.push(requs[key]);
      }
    }

    const mappedRequs = activeRequs ? activeRequs.map(requ =>
      <SetsRequItem key={requ.requ_id}
        data={requ}
      />
    ) : [];

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text" className="form-control"  value={data.requ_desc}
              name="requ_desc" onChange={this.updateInput}
              placeholder="Краткое название" autoFocus />
          </div>
          <div className="form-inline">
            <div className="form-group">
              <button  type="button" className="btn btn-success"
                onClick={this.saveItem} title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>
            </div>{" "}
            <div className="form-group">
              <button type="button" className="btn btn-default"
                onClick={this.cancelAdding} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>
            </div>
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        <td>
          <textarea type="text" className="form-control" value={data.requ_long}
            name="requ_long" onChange={this.updateInput} />
        </td>
        <td>
          <textarea type="text" className="form-control" value={data.requ_addr}
            name="requ_addr" onChange={this.updateInput}
            placeholder="Адрес" title="Адрес" />
          <input type="text" className="form-control"  value={data.requ_inn}
            name="requ_inn" onChange={this.updateInput}
            placeholder="ИНН" title="ИНН" />
          <input type="text" className="form-control"  value={data.requ_kpp}
            name="requ_kpp" onChange={this.updateInput}
            placeholder="КПП" title="КПП" />
          <input type="text" className="form-control"  value={data.requ_dir}
            name="requ_dir" onChange={this.updateInput}
            placeholder="Директор" title="Директор" />
          <input type="text" className="form-control"  value={data.requ_buh}
            name="requ_buh" onChange={this.updateInput}
            placeholder="Гл. бухгалтер" title="Гл. бухгалтер" />
        </td>
        <td>
          <textarea type="text" className="form-control" value={data.requ_bname}
            name="requ_bname" onChange={this.updateInput}
            placeholder="Банк" title="Банк" />
          <textarea type="text" className="form-control" value={data.requ_baddr}
            name="requ_baddr" onChange={this.updateInput}
            placeholder="Адрес" title="Адрес" />
          <input type="text" className="form-control"  value={data.requ_bik}
            name="requ_bik" onChange={this.updateInput}
            placeholder="БИК" title="БИК" />
          <input type="text" className="form-control"  value={data.requ_cacc}
            name="requ_cacc" onChange={this.updateInput}
            placeholder="Р/с" title="Р/с" />
          <input type="text" className="form-control"  value={data.requ_bacc}
            name="requ_bacc" onChange={this.updateInput}
            placeholder="К/с" title="К/с" />
        </td>
      </tr>
      :
      <tr onClick={this.startAdding}>
        <td></td>
        <td><u>Нажмите, чтобы добавить реквизиты</u></td>
        <td></td><td></td>
      </tr>;

    return (
      <div>
        <h3 className="pull-right">Реквизиты "{compDesc}"</h3>
        <div className="form-group form-inline">
          <button className="btn btn-default"
            onClick={this.goBack}>Назад</button>
          {" "}
          <button className="btn btn-primary"
            onClick={this.startAdding}>Создать</button>
        </div>
        <table className="table">
          <thead>
            <tr>
              <th className="col-sm-2">Краткое название</th>
              <th className="col-sm-4">Название для печатных форм</th>
              <th className="col-sm-3">Адрес, ИНН, КПП, директор, бухгалтер</th>
              <th className="col-sm-3">Банк, адрес, БИК, р/с, к/с</th>
            </tr>
          </thead>
          <tbody>
            {mappedRequs}
            {addNew}
          </tbody>
        </table>
      </div>
    )

  }
}

SetsRequ.contextTypes = {
  router: PropTypes.object.isRequired
}

function mapOrdersToProps(store) {
  return {
    requs: store.requs,
    comps: store.comps
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets })(SetsRequ);



// WEBPACK FOOTER //
// ./src/components/settings/SetsRequ.js